/* tslint:disable */
/* eslint-disable */
/**
 * Web App core API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum MachineConnectivityType {
    INTEGRATED = 'INTEGRATED',
    EXTERNAL = 'EXTERNAL',
    UNCONNECTED = 'UNCONNECTED'
}


export function MachineConnectivityTypeFromJSON(json: any): MachineConnectivityType {
    return MachineConnectivityTypeFromJSONTyped(json, false);
}

export function MachineConnectivityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): MachineConnectivityType {
    return json as MachineConnectivityType;
}

export function MachineConnectivityTypeToJSON(value?: MachineConnectivityType | null): any {
    return value as any;
}

